export const PageNames = {
  Redesign: 'Marriott Media Network',
  MLandingPage: 'Marriott Media Network Landing',
  Home: 'Marriott Media Network - Home',
  PartnerStories: 'Marriott Media Network - Partner Stories',
  OurPlatform: 'Marriott Media Network - Our Platform',
  OnProperty: 'Marriott Media Network - On Property',
  OffsiteDigital: 'Marriott Media Network - Offsite Digital',
  MarriottDigital: 'Marriott Media Network - Marriott Digital',
  Insights: 'Marriott Media Network - Insights',
  Contact: 'Marriott Media Network - Contact',
  ContactModal: 'Marriott Media Network - Contact Modal',
  GreaterChinaLaunch: 'Marriott Media Network - Marriott Media Greater China Launch',
};

const SITE_ID = 'MMN Project';
const LANGUAGE_DOMAIN = 'US';

const PAGE_NAME_MAPPING = {
  '/': PageNames.Redesign,
  '/index.html': PageNames.Redesign,
  '/landing': PageNames.MLandingPage,
};

const adobeDataLayer = window.adobeDataLayer || [];
export default adobeDataLayer;

export const getAnalyticsPageName = (location) => {
  return PAGE_NAME_MAPPING[location.pathname] || location.pathname;
};

export { SITE_ID, LANGUAGE_DOMAIN };
